exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-purple[data-v-15f83aa8]{\n    background-color: purple;\n}\n.size-tabela[data-v-15f83aa8]{\n    width: 700px;\n}\n\n", ""]);

// exports
